module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-xs-12 col-lg-10 col-lg-offset-1"
  }, [_c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "form-group col-xs-12 col-sm-6"
  }, [_c('label', {
    attrs: {
      "for": "category"
    }
  }, [_vm._v("Category")]), _vm._v(" "), _c('nv-select', {
    staticClass: "form-control",
    attrs: {
      "id": "category"
    },
    model: {
      value: (_vm.config.category),
      callback: function($$v) {
        _vm.$set(_vm.config, "category", $$v)
      },
      expression: "config.category"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select category--")]), _vm._v(" "), _vm._l((_vm.categories), function(caption, value) {
    return _c('option', {
      key: value,
      domProps: {
        "value": value
      }
    }, [_vm._v(_vm._s(caption))])
  })], 2)], 1), _vm._v(" "), (_vm.isUsersWithoutMethod) ? _c('div', {
    staticClass: "form-group col-xs-12 col-sm-6"
  }, [_c('label', {
    attrs: {
      "for": "reason"
    }
  }, [_vm._v("Reason")]), _vm._v(" "), _c('nv-select', {
    staticClass: "form-control",
    attrs: {
      "id": "category"
    },
    model: {
      value: (_vm.config.reason),
      callback: function($$v) {
        _vm.$set(_vm.config, "reason", $$v)
      },
      expression: "config.reason"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select Reason--")]), _vm._v(" "), _vm._l((_vm.allReasonse), function(value, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": value
      }
    }, [_vm._v(_vm._s(value))])
  })], 2)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-6"
  }, [_c('label', {
    attrs: {
      "for": "description"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.description),
      expression: "config.description"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "4",
      "id": "description",
      "placeholder": "Description"
    },
    domProps: {
      "value": (_vm.config.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.config, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-6"
  }, [_c('label', {
    attrs: {
      "for": "date-from"
    }
  }, [_vm._v("Date from")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.from),
      expression: "config.from"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "id": "date-from",
      "placeholder": "From"
    },
    domProps: {
      "value": (_vm.config.from)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.config, "from", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-6"
  }, [_c('label', {
    attrs: {
      "for": "date-to"
    }
  }, [_vm._v("Date to")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.to),
      expression: "config.to"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "id": "date-to",
      "placeholder": "To"
    },
    domProps: {
      "value": (_vm.config.to)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.config, "to", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-6"
  }, [_c('label', {
    attrs: {
      "for": "keyword"
    }
  }, [_vm._v("Keyword")]), _vm._v(" "), _c('vue-tags-input', {
    staticClass: "form-control",
    attrs: {
      "id": "tag-input",
      "tags": _vm.config.keywords,
      "add-only-from-autocomplete": true,
      "autocomplete-items": _vm.filteredKeywords
    },
    on: {
      "tags-changed": _vm.update
    },
    model: {
      value: (_vm.currentKeyword),
      callback: function($$v) {
        _vm.currentKeyword = $$v
      },
      expression: "currentKeyword"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-6"
  }, [_c('label', {
    attrs: {
      "for": "gender"
    }
  }, [_vm._v("Gender")]), _vm._v(" "), _c('nv-select', {
    staticClass: "form-control",
    attrs: {
      "id": "gender"
    },
    model: {
      value: (_vm.config.gender),
      callback: function($$v) {
        _vm.$set(_vm.config, "gender", $$v)
      },
      expression: "config.gender"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--choose gender--")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "man"
    }
  }, [_vm._v("Male")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "woman"
    }
  }, [_vm._v("Female")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-6"
  }, [_c('label', {
    attrs: {
      "for": "location"
    }
  }, [_vm._v("Location")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.location),
      expression: "config.location"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "location",
      "placeholder": "location"
    },
    domProps: {
      "value": (_vm.config.location)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.config, "location", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-6"
  }, [_c('label', {
    attrs: {
      "for": "channel"
    }
  }, [_vm._v("Channel")]), _vm._v(" "), _c('nv-select', {
    staticClass: "form-control",
    attrs: {
      "id": "channel"
    },
    model: {
      value: (_vm.config.channel),
      callback: function($$v) {
        _vm.$set(_vm.config, "channel", $$v)
      },
      expression: "config.channel"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--choose channel--")]), _vm._v(" "), _vm._l((_vm.channels), function(caption, value) {
    return _c('option', {
      key: value,
      domProps: {
        "value": value
      }
    }, [_vm._v(_vm._s(caption))])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-6"
  }, [_c('label', {
    attrs: {
      "for": "requires-response"
    }
  }, [_vm._v("Requires User Response")]), _vm._v(" "), _c('nv-select', {
    staticClass: "form-control",
    attrs: {
      "id": "requires-response"
    },
    model: {
      value: (_vm.config.requiresResponse),
      callback: function($$v) {
        _vm.$set(_vm.config, "requiresResponse", $$v)
      },
      expression: "config.requiresResponse"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select option--")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "yes"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "no"
    }
  }, [_vm._v("No")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12 col-sm-6"
  }, [_c('label', {
    attrs: {
      "for": "generic-app"
    }
  }, [_vm._v("Conversation")]), _vm._v(" "), _c('nv-select', {
    staticClass: "form-control",
    model: {
      value: (_vm.config.genericApp),
      callback: function($$v) {
        _vm.$set(_vm.config, "genericApp", $$v)
      },
      expression: "config.genericApp"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select App--")]), _vm._v(" "), _vm._l((_vm.allApps), function(each, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": each.value
      }
    }, [_vm._v("\n                        " + _vm._s(each.name) + "\n                    ")])
  })], 2)], 1), _vm._v(" "), _c('br', {
    attrs: {
      "clear": "all"
    }
  }), _vm._v(" "), _c('nudge-message'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.processing
    },
    on: {
      "click": _vm.query
    }
  }, [_vm._v("Query")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.queryCount) ? _c('h4', [_vm._v("The nudge will be sent to " + _vm._s(_vm.queryCount) + " user(s)")]) : _vm._e(), _vm._v(" "), (_vm.queryCount) ? _c('button', {
    staticClass: "btn btn-primary btn-big",
    attrs: {
      "disabled": _vm.processing,
      "type": "submit"
    },
    on: {
      "click": _vm.nudge
    }
  }, [_vm._v("Nudge Users")]) : _vm._e()], 1)])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n      SMS NUDGE\n      "), _c('small', [_vm._v("Create A Nudge")])]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Home")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Create A Nudge")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-5f7379e4","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/nudge/new.vue
// module id = SW1q
// module chunks = 1